import { StoreState } from "../RootReducer";

export const getDashboard14DayStats = (state: StoreState) =>
	state.Dashboard.fleetStats;

export const getDashboardRootJourneys = (state: StoreState) =>
	state.Dashboard.rootJourneys;

export const getDashboardRootReports = (state: StoreState) =>
	state.Dashboard.rootReports;

export const getDashboardGroupJourneys = (state: StoreState) =>
	state.Dashboard.groupJourneys;

export const getDashboardPillarSummaryTimeSelectionId = (state: StoreState) =>
	state.Dashboard.pillarSummaryTimeSelectionId;

export const getDashboardPillarBoxplots = (state: StoreState) =>
	state.Dashboard.pillarBoxplots;

export const getDashboardComparisonLevels = (state: StoreState) =>
	state.Dashboard.comparisonLevels;

export const selectCurrentScopeUserCount = (state: StoreState) =>
	state.Dashboard.userCount;
